import Masthead from "./components/Masthead";
import Hero from "./components/Hero";
import TopicGrid from "./components/TopicGrid";
import HeatRank from "./components/HeatRank";
import TrackTimeline from "./components/TrackTimeline";
import ProgressGrid from "./components/ProgressGrid";
import Responses from "./components/Responses";
import Community from "./components/Community";
import FooterBand from "./components/FooterBand";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Masthead />
      <main>
        <Hero />
        <TopicGrid />
        <HeatRank />
        <TrackTimeline />
        <ProgressGrid />
        <Responses />
        <Community />
      </main>
      <FooterBand />
    </div>
  );
}